import * as React from "react";
import {
  ShowProps,
  Button,
  DateInput,
  useRecordContext,
  useCreate,
  useNotify,
  useRefresh,
} from "react-admin";
import { Box } from "@mui/material";
import { DialogForm } from "../Dialog";
import { useState } from "react";
import { RichTextInput } from "ra-input-rich-text";
import { validateFutureDate } from "../../../constants";

export const CreateInterviewModal: React.FC<ShowProps> = (props) => {
  const record = useRecordContext();

  const [interviewDate, setInterviewDate] = useState("");
  const [comment, setComment] = useState("");
  const [open, setOpen] = useState<boolean>(false);

  const [create, { isLoading }] = useCreate();
  const notify = useNotify();
  const refresh = useRefresh();

  const handleInit = (): void => {
    setComment("");
    setInterviewDate(new Date().toISOString());
    setOpen(true);
  };

  const handleCancel = (): void => setOpen(false);

  const handleUpdate = async (): Promise<void> => {
    try {
      await create(
        "interviews",
        {
          data: {
            comment: comment,
            interviewDate: interviewDate,
            applicationId: record?.id,
          },
        },
        {
          onSuccess: () => {
            notify(`Entrevista creada con éxito`, { type: "success" });
            setOpen(false);
            refresh();
          },
          onError: (error) => {
            const errorMessage =
              error instanceof Error
                ? error.message
                : "No se pudo crear la entrevista";
            notify(`Error al crear entrevista: ${errorMessage}`, {
              type: "error",
            });
          },
        }
      );
    } catch (error) {
      const errorMessage =
        error instanceof Error
          ? error.message
          : "No se pudo crear la entrevista";
      notify(`Error al crear entrevista: ${errorMessage}`, { type: "error" });
    }
  };

  if (!record) {
    return null; // Don't show button if record is not available
  }

  return (
    <div>
      <Button label="+ Registrar entrevista" onClick={handleInit} />
      <DialogForm
        open={open}
        onCancel={handleCancel}
        onSubmit={handleUpdate}
        submitLabel="Registrar entrevista"
        cancelLabel="Cancelar"
        loading={isLoading}
      >
        <Box sx={{ display: "flex", gap: "16px" }}>
          <DateInput
            source="interviewDate"
            label="Fecha de entrevista"
            defaultValue={new Date()}
            onChange={(e): void => setInterviewDate(e.target.value)}
            validate={validateFutureDate}
            fullWidth
          />
        </Box>
        <RichTextInput
          source="comment"
          label="Notas"
          onChange={(e): void => setComment(e)}
        />
      </DialogForm>
    </div>
  );
};
